import { getAdminErrorMessage } from '../adminErrorModel'

export type ParsedRainforestEvent = {
  isValid: boolean
  eventType: string | null
}

export const parseRainforestEventPayload = (raw: string): ParsedRainforestEvent => {
  const trimmed = raw.trim()
  if (trimmed === '') {
    return { isValid: false, eventType: null }
  }

  try {
    const parsed = JSON.parse(trimmed)
    if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return { isValid: false, eventType: null }
    }
    return { isValid: true, eventType: readEventType(parsed) }
  } catch {
    return { isValid: false, eventType: null }
  }
}

const readEventType = (parsed: Record<string, unknown>): string | null => {
  const value = parsed.event_type ?? parsed.eventType
  if (typeof value === 'string' && value.trim() !== '') {
    return value
  }
  return null
}

export const getReprocessErrorMessage = (error: unknown): string => {
  return getAdminErrorMessage(error, 'Failed to reprocess the Rainforest event. Please verify the payload and try again.')
}
